module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cd-80689945f2e56fea5e71b64252b65660.svg";